import { Persona } from '@/state/AppConfig'
import { IScene } from '@/webgl/engine/IScene'
import Renderer from '@/webgl/Renderer'
import Caris1Scene from '@/webgl/runner/scenarios/caris_1/Caris1Scene'
import Caris2Scene from '@/webgl/runner/scenarios/caris_2/Caris2Scene'
import DummyScenario from '@/webgl/runner/scenarios/dummy/DummyScenario'
import Francesca1Scene from '@/webgl/runner/scenarios/francesca_1/Francesca1Scene'
import Francesca2Scene from '@/webgl/runner/scenarios/francesca_2/Francesca2Scene'
import Pedro1Scene from '@/webgl/runner/scenarios/pedro_1/Pedro1Scene'
import Pedro2Scene from '@/webgl/runner/scenarios/pedro_2/Pedro2Scene'
import { AudioSegmentSetup, ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'
import { TurningPointOptions as TunringPointSetup } from '@/webgl/runner/scenarios/segments/TurningPoint'
import { SequenceConfig } from '@/webgl/runner/scenarios/SequenceConfig.types'

export enum ScenarioID {
  Pedro_1 = 0,
  Pedro_2 = 1,
  Caris_1 = 2,
  Caris_2 = 3,
  Francesca_1 = 4,
  Francesca_2 = 5,
  Dummy = 100,
}

const scenarios: Record<Persona, ScenarioID[]> = {
  pedro: [ScenarioID.Pedro_1, ScenarioID.Pedro_2],
  caris: [ScenarioID.Caris_1, ScenarioID.Caris_2],
  francesca: [ScenarioID.Francesca_1, ScenarioID.Francesca_2],
}

export function getScenarioID(persona: Persona, scenario: number): ScenarioID {
  if (scenarios[persona] === undefined) {
    console.warn('Unknown persona', persona)
    return ScenarioID.Dummy
  }

  if (scenarios[persona][scenario] === undefined) {
    console.warn('Unknown scenario', scenario)
    return ScenarioID.Dummy
  }

  return scenarios[persona][scenario]
}

export function createScenario(scenario: ScenarioID, renderer: Renderer): IScene {
  switch (scenario) {
    case ScenarioID.Pedro_1:
      return new Pedro1Scene(renderer)
    case ScenarioID.Pedro_2:
      return new Pedro2Scene(renderer)
    case ScenarioID.Francesca_1:
      return new Francesca1Scene(renderer)
    case ScenarioID.Francesca_2:
      return new Francesca2Scene(renderer)
    case ScenarioID.Caris_1:
      return new Caris1Scene(renderer)
    case ScenarioID.Caris_2:
      return new Caris2Scene(renderer)
    case ScenarioID.Dummy:
    default:
      console.warn('Unknown scenario', ScenarioID[scenario])
      return new DummyScenario(renderer)
  }
}

export function getPlaySequence(setup: ScenarioSetup, id: string): SequenceConfig {
  for (const sequence of setup.sequences) {
    if (sequence.id == id) return sequence
  }
  throw `Sequence ${id} not found`
}

export function getTurningPoint(setup: ScenarioSetup, id: string): TunringPointSetup {
  for (const turningPoint of setup.turningPoints) {
    if (turningPoint.id == id) return turningPoint
  }
  throw `TurningPoint ${id} not found`
}

export function getAudioSegement(setup: ScenarioSetup, id: string): AudioSegmentSetup {
  for (const segment of setup.audioSegments) {
    if (segment.id == id) return segment
  }
  throw `AudioSegment ${id} not found`
}
